import { ReactNode, useState } from 'react';

import { PermissionsContext } from '../permissionsContext/PermissionsContext';

import { UserPermissions, PermissionsContextValue, AccessFlags } from './PermissionsContext.types';

type PermissionsContextControllerProps = {
  children: ReactNode;
  initialPerms?: UserPermissions | null;
  initialAccessFlags?: Partial<AccessFlags>;
};

const defaultAccessFlags: AccessFlags = {
  accessAllData: false,
  accessFeaturedCards: false,
  accessNoOrganizations: false,
};

export const PermissionsContextController = ({
  children,
  initialPerms = null,
  initialAccessFlags,
}: PermissionsContextControllerProps) => {
  const [perms, setPerms] = useState<UserPermissions | null>(initialPerms ?? null);
  const [accessFlags, setAccessFlags] = useState<AccessFlags>({
    ...defaultAccessFlags,
    ...initialAccessFlags,
  });

  const value: PermissionsContextValue = {
    perms,
    setPerms,
    accessFlags,
    setAccessFlags,
  };

  return <PermissionsContext.Provider value={value}>{children}</PermissionsContext.Provider>;
};
